import * as React from 'react';
import { Avatar, Divider, IconButton, PaletteMode, Stack, Tooltip } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import ToggleColourMode from './ToggleColourMode';

const logoStyle = {
  width: '55px',
  height: 'auto',
  cursor: 'pointer',
};

interface AppAppBarProps {
  mode: PaletteMode;
  toggleColorMode: () => void;
}

function AppAppBar({ mode, toggleColorMode }: AppAppBarProps) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
      setOpen(false);
    }
  };
  const profilephoto = require('../images/profilephoto.jpg');
  const handleLinkedInClick = ()=>{
    window.open('https://www.linkedin.com/in/eric-wu-profile','_blank');
  };
  const handleGithubClick = ()=>{
    window.open('https://github.com/EWU0001','_blank');
  };
  const handleEmailClick = ()=>{
    const email = 'ericwu321@gmail.com';
    const mailtoUrl = `mailto:${email}`;
    window.open(mailtoUrl);
  };

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'transparent',
          backgroundImage: 'none',
          mt: 2,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
              borderRadius: '999px',
              bgcolor:
                theme.palette.mode === 'light'
                  ? 'rgba(255, 255, 255, 0.4)'
                  : 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(24px)',
              maxHeight: 40,
              border: '1px solid',
              borderColor: 'divider',
              boxShadow:
                theme.palette.mode === 'light'
                  ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                  : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)',
            })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '-18px',
                px: 0,
              }}
            >
              <Avatar
                src={profilephoto}
                style={logoStyle}
                alt="logo of sitemark"
              />
              <Box sx={{ display: { xs: 'none', md: 'flex', textTransform:'uppercase'} }}>
                <MenuItem
                  onClick={() => scrollToSection('projects')}
                  sx={{ py: '6px', px: '18px' }}
                >
                  <Typography variant="subtitle2" color="text.primary" fontWeight='bold'>
                  Projects
                  </Typography>
                </MenuItem>
                
                <MenuItem
                  onClick={() => scrollToSection('employment')}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="subtitle2" color="text.primary" fontWeight='bold'>
                  Employment
                  </Typography>
                </MenuItem>
                
                <MenuItem
                  onClick={() => scrollToSection('education')}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="subtitle2" color="text.primary" fontWeight='bold'>
                  Education
                  </Typography>
                </MenuItem>                

                <MenuItem
                  onClick={() => scrollToSection('skills')}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="subtitle2" color="text.primary" fontWeight='bold'>
                  Skills
                  </Typography>
                </MenuItem>

              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                gap: 0.5,
                alignItems: 'center',
              }}
            >
              <IconButton onClick={()=>handleGithubClick()}><GitHubIcon/></IconButton>
              <IconButton onClick={()=>handleLinkedInClick()}><LinkedInIcon/></IconButton>
              <Tooltip title='Email: ericwu321@gmail.com'>
              <IconButton onClick={()=>handleEmailClick()}><EmailIcon/></IconButton>
              </Tooltip>
              <ToggleColourMode mode={mode} toggleColorMode={toggleColorMode} />
            </Box>
            {/* small screen */}
            <Box sx={{ display: { sm: '', md: 'none' } }}>
              <Button
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: '30px', p: '4px' }}
              >
                <MenuIcon />
              </Button>
              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: '60dvw',
                    p: 2,
                    backgroundColor: 'background.paper',
                    flexGrow: 1,
                    
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'end',
                      flexGrow: 1,
                    }}
                  >
                  <ToggleColourMode mode={mode} toggleColorMode={toggleColorMode} />
                  </Box>
                  <MenuItem onClick={() => scrollToSection('projects')} sx={{fontWeight:'bold', textTransform:'uppercase'}}>
                    Projects
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection('employment')} sx={{fontWeight:'bold', textTransform:'uppercase'}}>
                    Employment
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection('education')} sx={{fontWeight:'bold', textTransform:'uppercase'}}>
                    Education
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection('skills')} sx={{fontWeight:'bold', textTransform:'uppercase'}}>
                    Skills
                  </MenuItem>
                  <Divider/>
                  <Stack direction='row' spacing={0.2} justifyContent='center'>
                    <MenuItem onClick={() => handleGithubClick()}>
                      <GitHubIcon/>
                    </MenuItem>
                    <MenuItem onClick={() => handleLinkedInClick()}>
                      <LinkedInIcon/>
                    </MenuItem>
                    <MenuItem onClick={() => handleEmailClick()}>
                      <EmailIcon/>
                    </MenuItem>
                  </Stack>
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

export default AppAppBar;